@if (isDataAvailable) {
<div id="chart">
  <h2 class="chart-title">
    {{ chartOptions.title.text }}
  </h2>
  <div class="chart-container">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [fill]="chartOptions.options.fill"
      [stroke]="chartOptions.options.stroke"
      [colors]="chartOptions.options.colors"
      [markers]="chartOptions.options.markers"
      [grid]="chartOptions.options.grid"
      [plotOptions]="chartOptions.options.plotOptions"
      [tooltip]="chartOptions.options.tooltip"
      [legend]="chartOptions.options.legend"
    ></apx-chart>
  </div>
</div>
} @else {
<div class="message">
  <p>No hay datos para mostrar :(</p>
</div>
}
